import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { AddCashierPageRoutingModule } from './add-cashier-routing.module';

import { AddCashierPage } from './add-cashier.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    AddCashierPageRoutingModule
  ],
  declarations: [AddCashierPage]
})
export class AddCashierPageModule {}
